import { render } from "./PageView.vue?vue&type=template&id=4b0b8409&scoped=true"
import script from "./PageView.vue?vue&type=script&lang=js"
export * from "./PageView.vue?vue&type=script&lang=js"

import "./PageView.vue?vue&type=style&index=0&id=4b0b8409&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0b8409"]])

export default __exports__